export const enum CharCode {
  U_ZERO_WIDTH_WHITESPACE = '\u200b',
}
